<template>
  <div
    :class="['cornered-frame', customClass]"
    ref="corneredFrame"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <CustomizableCorner
      v-for="position in cornerPositions"
      :key="position"
      :color="computedCornerColor"
      :width="cornerWidth"
      :height="cornerHeight"
      :cornerThickness="cornerThickness"
      :class="`corner ${position}`"
    />
    <slot />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import CustomizableCorner from "./CustomizableCorner.vue";

export default defineComponent({
  name: "CorneredFrame",
  components: {
    CustomizableCorner,
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
    cornerColor: {
      type: String,
      default: "#15CA5C",
    },
    hoverCornerColor: {
      type: String,
      default: null,
    },
    cornerWidth: {
      type: [Number, String],
      default: 3,
    },
    cornerHeight: {
      type: [Number, String],
      default: 3,
    },
    cornerThickness: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      isHovered: false,
    };
  },
  computed: {
    cornerPositions() {
      return ["top-left", "top-right", "bottom-left", "bottom-right"];
    },
    computedCornerColor() {
      return this.isHovered && this.hoverCornerColor
        ? this.hoverCornerColor
        : this.cornerColor;
    },
  },
  methods: {
    onMouseEnter() {
      if (this.hoverCornerColor) {
        this.isHovered = true;
      }
    },
    onMouseLeave() {
      this.isHovered = false;
    },
  },
});
</script>

<style scoped>
.cornered-frame {
  position: relative;
  z-index: 1;
}

.corner {
  position: absolute;
  z-index: 1;
}

.top-left {
  top: 0;
  left: 0;
}

.top-right {
  top: 0;
  right: 0;
  transform: rotate(90deg);
}

.bottom-left {
  bottom: 0;
  left: 0;
  transform: rotate(-90deg);
}

.bottom-right {
  bottom: 0;
  right: 0;
  transform: rotate(180deg);
}
</style>
